"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { SelectBoxItem } from "@/components/ui/SelectBox";
import { useTagFilters } from "@/queries/catalog";
export function useTagOptions() {
  const $ = _c(11);
  const {
    data: tagFilters
  } = useTagFilters();
  let t0;
  if ($[0] !== tagFilters?.data?.genres) {
    t0 = tagFilters?.data?.genres ?? [];
    $[0] = tagFilters?.data?.genres;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = t0.map(_temp);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const genreOptions = t1;
  let t2;
  if ($[4] !== tagFilters?.data?.countries) {
    t2 = tagFilters?.data?.countries ?? [];
    $[4] = tagFilters?.data?.countries;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = t2.map(_temp2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const countryOptions = t3;
  let t4;
  if ($[8] !== countryOptions || $[9] !== genreOptions) {
    t4 = {
      genreOptions,
      countryOptions
    };
    $[8] = countryOptions;
    $[9] = genreOptions;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(tag_0, index_0) {
  return {
    id: tag_0.uuid ?? `${tag_0.name_fa || tag_0.name_en || "country"}-${index_0}`,
    label: tag_0.name_fa || tag_0.name_en || "",
    value: tag_0.uuid ?? ""
  };
}
function _temp(tag, index) {
  return {
    id: tag.uuid ?? `${tag.name_fa || tag.name_en || "genre"}-${index}`,
    label: tag.name_fa || tag.name_en || "",
    value: tag.uuid ?? ""
  };
}